import { Navigate, useParams, useRoutes } from "react-router-dom";

import EditPage from "./edit";
import IndexPage from "./index";

export default () =>
  useRoutes([
    { path: "/:journalId", element: <WithParameters component={EditPage}/> },
    { path: "/", element: <WithParameters component={IndexPage}/> },
    { path: "/*", element: <Navigate to="/not-found"/> },
  ]);

function WithParameters({ component: Comp }) {
  const parameters = useParams();
  return <Comp {...parameters} />;
}
